import React from 'react';
import { useField } from 'formik';
import FieldWrapper from './wrapper/FieldWrapper';
import ErrorWrapper from './wrapper/ErrorWrapper';
import Select from 'react-select';

export const customStyles = {
  option: (base, state) => ({
    ...base,
    color: '#F2F2F2',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: '#20B4E1',
    },
  }),
  control: (base) => ({
    ...base,
    borderColor: '#8CABDA',
    borderRadius: 2,
    color: '#F2F2F2',
    cursor: 'pointer',
    height: 32,
    backgroundColor: 'transparent',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#F2F2F2',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 2,
    backgroundColor: '#242F3D',
    color: '#F2F2F2',
    border: '1px solid #8CABDA'
  }),
  placeholder: (base) => ({
    ...base,
    color: '#F2F2F2',
  }),
  indicatorSeparator: (base) => ({ ...base, display: 'none' }),
  input: (base) => ({
    ...base,
    color: '#f2f2f2'
  })
};

const DropdownField = (props) => {
  const [field, meta, helper] = useField(props);
  
  const onOptionChange = (valObj) => {
    if (props.onChange) props.onChange(valObj);
    helper.setValue(valObj.value);
  };

  return (
    <FieldWrapper htmlFor={props.name}>
      <strong>{props.label}</strong>
      <Select
        id={props.name}
        {...field}
        {...props}
        value={props.options.find(o => o.value === field.value)}
        onChange={onOptionChange}
        styles={customStyles}
      />
      { meta.touched && meta.error &&
        <ErrorWrapper name={props.name}>
          {meta.error}
        </ErrorWrapper>
      }
    </FieldWrapper>
  );
};

export default DropdownField;
